<ng-container [formGroup]="parent.entryForm">

        <input 
        [nbDatepicker]="datepickerRight" 
        formControlName="{{field.name + '-visible'}}" 
        [showStatusIconOn]="{ showOnControlStatus: field.statusIconOn ?? ['valid','invalid','pending'], invalidWhen: field.invalidWhen ?? 'touchedOrDirty' }"


        status="{{
                !field.required && !parent.entryForm.controls[field.name].touched && !parent.entryForm.controls[field.name].dirty ? 'basic' :
                parent.entryForm.controls[field.name].status == 'VALID' ? 'success' :
                parent.entryForm.controls[field.name].pristine && parent.entryForm.controls[field.name].status == 'INVALID' ? 'warning' : 
                'primary'
              }}"  
              
        type="text" 
        nbInput 
        fullWidth 
        id="{{'input' + field.name}}" 
        placeholder="{{field.label}}"
        (input)="parent.setDateToFormcontrol($event, field.name, field.type)"
        (blur)="parent.checkValidity(field.name)"
        >
        
        <nb-datepicker 
        #datepickerRight
        format="dd-MM-yyyy"
        (dateChange)="parent.setCorrectDate($event, field.name, 'datepicker')" 
        >
        </nb-datepicker>


</ng-container>
    